import { render, staticRenderFns } from "./verification-orders-detail.vue?vue&type=template&id=0c3c0cb7&scoped=true&"
import script from "./verification-orders-detail.vue?vue&type=script&lang=js&"
export * from "./verification-orders-detail.vue?vue&type=script&lang=js&"
import style0 from "./verification-orders-detail.vue?vue&type=style&index=0&id=0c3c0cb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3c0cb7",
  null
  
)

export default component.exports